/**
 * This is a generic version of the localization dropdown input that can be used for any styled select input.
 */
class DropdownSelector extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener(
      'click',
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    );
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.elements.panel.addEventListener('click', this.onPanelClick.bind(this));

    // Outside click listener
    document.addEventListener('click', (e) => {
      if (
        e.target !== this.elements.button &&
        !this.elements.panel.contains(e.target)
      ) {
        this.hidePanel();
      }
    });
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    // Stop event from bubbling to modal
    event.stopPropagation();
    this.hidePanel();
    this.elements.button.focus();
  }

  onPanelClick(event) {
    const item = event.target.closest('a');
    if (!item) return;

    event.preventDefault();
    this.onItemClick(item);
  }

  onItemClick(item) {
    this.elements.input.value = item.dataset.value;

    const textElement = this.elements.button.querySelector(
      '.dropdown__button-text'
    );

    if (textElement) {
      const selectedOption = item.textContent.trim();
      textElement.textContent = selectedOption;
    }

    this.hidePanel();
  }

  openSelector() {
    this.elements.panel.style.maxHeight = `${this.getMaximumPanelHeight()}px`;

    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  getMaximumPanelHeight() {
    const paddingBottom = 130;

    return (
      window.innerHeight -
      this.elements.button.getBoundingClientRect().bottom -
      paddingBottom
    );
  }
}

if (!customElements.get('dropdown-selector')) {
  customElements.define('dropdown-selector', DropdownSelector);
}
